import { takeLatest, put, select } from 'redux-saga/effects';
import { CHATS_FILTER_TYPES } from '../../../constants/chat';
import { consts as reqFilters } from '../reqFilters';
import { consts as filters } from '../filters';
import { typeSelector } from '../selectors/filters';
import { selectLoggedUserHasRelations } from '../../data/selectors';
import {
  hasProviderProfileSelector,
  hasPatientProfileSelector,
} from '../../context/selectors';

const filterValue = (isProvider, isPatient, hasRelations) => {
  let value = CHATS_FILTER_TYPES.PATIENT;

  if (isProvider) {
    value = CHATS_FILTER_TYPES.PROVIDER;
  } else if (isPatient || hasRelations) {
    value = CHATS_FILTER_TYPES.PATIENT;
  }
  return value;
};

function* setAvailableFiltersWorker(action) {
  const selectedType = yield select(typeSelector);
  const isPatient = yield select(hasPatientProfileSelector);
  const isProvider = yield select(hasProviderProfileSelector);
  const hasRelations = yield select(selectLoggedUserHasRelations);

  if (!selectedType) {
    yield put({
      type: filters.SET_TYPE,
      payload: filterValue(isProvider, isPatient, hasRelations),
    });
  }

  yield put({
    type: filters.SET_AVAILABLE_FILTERS,
    payload: action.payload,
  });
}

export default function* setAvailableFiltersSaga() {
  yield takeLatest(reqFilters.SUCCEED, setAvailableFiltersWorker);
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas/filters.js